export default __webpack_public_path__ + "static/media/scenario-a-home-checkin.3548c043.png";